import types from 'actions/types'
import {combineReducers} from 'redux'
import {get} from "lodash"

export const status = (state = null, action) => {
  switch (action.type) {
    case types.ZOHO_STATUS_SUCCESS:
    case types.ZOHO_AUTHENTICATE_SUCCESS:
    case types.ZOHO_ACTIVATE_SUCCESS:
    case types.ZOHO_DEACTIVATE_SUCCESS:
    case types.ZOHO_SYNC_UPDATE_SUCCESS:
      return action.status
    default:
      return state
  }
}

export const connecting = (state = false, action) => {
  switch (action.type) {
    case types.ZOHO_CONNECT_START:
      return true
    case types.ZOHO_ACTIVATE_SUCCESS:
    case types.ZOHO_DEACTIVATE_SUCCESS:
    case types.ZOHO_CONNECT_CANCEL:
      return false
    case types.ZOHO_INITIALIZE_WORKSPACE:
      return true
    default:
      return state
  }
}

export const connectStep = (state = 0, action) => {
  switch (action.type) {
    case types.ZOHO_CONNECT_START:
      return action.step || state
    case types.ZOHO_SET_CONNECT_STEP:
      return action.step
    case types.ZOHO_INITIALIZE_WORKSPACE:
      return 1
    default:
      return state
  }
}

export const changeRangeSelecting = (state = false, action) => {
  switch (action.type) {
    case types.ZOHO_CHANGE_RANGE_START:
      return true
    case types.ZOHO_SYNC_UPDATE_SUCCESS:
    case types.ZOHO_CHANGE_RANGE_CANCEL:
      return false
    default:
      return state
  }
}

export const reauthorising = (state = false, action) => {
  switch (action.type) {
    case types.ZOHO_REAUTHORISE_START:
      return true
    case types.ZOHO_REAUTHORISE_CANCEL:
    case types.ZOHO_AUTHENTICATE_SUCCESS:
      return false
    default:
      return state
  }
}

export const authenticating = (state = false, action) => {
  switch (action.type) {
    case types.ZOHO_AUTHENTICATE_ATTEMPT:
      return true
    case types.ZOHO_AUTHENTICATE_SUCCESS:
    case types.ZOHO_AUTHENTICATE_FAILURE:
      return false
    default:
      return state
  }
}

export const authenticationError = (state = null, action) => {
  switch (action.type) {
    case types.ZOHO_AUTHENTICATE_ATTEMPT:
      return null
    case types.ZOHO_AUTHENTICATE_FAILURE:
      return action.message
    default:
      return state
  }
}

export const activating = (state = false, action) => {
  switch (action.type) {
    case types.ZOHO_ACTIVATE_ATTEMPT:
      return true
    case types.ZOHO_ACTIVATE_SUCCESS:
    case types.ZOHO_ACTIVATE_FAILURE:
      return false
    default:
      return state
  }
}

export const activationError = (state = null, action) => {
  switch (action.type) {
    case types.ZOHO_ACTIVATE_ATTEMPT:
      return null
    case types.ZOHO_ACTIVATE_FAILURE:
      return action.message
    default:
      return state
  }
}

export const deactivating = (state = false, action) => {
  switch (action.type) {
    case types.ZOHO_DEACTIVATE_ATTEMPT:
      return true
    case types.ZOHO_DEACTIVATE_SUCCESS:
    case types.ZOHO_DEACTIVATE_FAILURE:
      return false
    default:
      return state
  }
}

export const changingRange = (state = false, action) => {
  switch (action.type) {
    case types.ZOHO_SYNC_UPDATE_ATTEMPT:
      return true
    case types.ZOHO_SYNC_UPDATE_SUCCESS:
    case types.ZOHO_SYNC_UPDATE_FAILURE:
      return false
    default:
      return state
  }
}

export const changeRangeError = (state = null, action) => {
  switch (action.type) {
    case types.ZOHO_SYNC_UPDATE_ATTEMPT:
      return null
    case types.ZOHO_SYNC_UPDATE_FAILURE:
      return action.message
    default:
      return state
  }
}

export const organisations = (state = [], action) => {
  switch (action.type) {
    case types.ZOHO_GET_ORGANISATIONS_SUCCESS:
      return action.organisations
    default:
      return state
  }
}

export const workspaces = (state = [], action) => {
  switch (action.type) {
    case types.ZOHO_GET_WORKSPACES_SUCCESS:
      return action.workspaces
    default:
      return state
  }
}

export const organisationId = (state = null, action) => {
  switch (action.type) {
    case types.ZOHO_SET_ORGANISATION_ID:
      return action.organisationId
    default:
      return state
  }
}

export const workspaceId = (state = null, action) => {
  switch (action.type) {
    case types.ZOHO_SET_WORKSPACE_ID:
      return action.workspaceId
    default:
      return state
  }
}

export const records = (state = null, action) => {
  switch (action.type) {
    case types.ZOHO_GET_RECORDS_SUCCESS:
      return action.records
    default:
      return state
  }
}

export const gettingOrganisations = (state = null, action) => {
  switch (action.type) {
    case types.ZOHO_GET_ORGANISATIONS_ATTEMPT:
      return true
    case types.ZOHO_GET_ORGANISATIONS_SUCCESS:
    case types.ZOHO_GET_ORGANISATIONS_FAILURE:
      return false
    default:
      return state
  }
}

export const gettingWorkspaces = (state = null, action) => {
  switch (action.type) {
    case types.ZOHO_GET_WORKSPACES_ATTEMPT:
      return true
    case types.ZOHO_GET_WORKSPACES_SUCCESS:
    case types.ZOHO_GET_WORKSPACES_FAILURE:
      return false
    default:
      return state
  }
}

export const gettingRecords = (state = null, action) => {
  switch (action.type) {
    case types.ZOHO_GET_RECORDS_ATTEMPT:
      return true
    case types.ZOHO_GET_RECORDS_SUCCESS:
    case types.ZOHO_GET_RECORDS_FAILURE:
      return false
    default:
      return state
  }
}

export const plan = (state = null, action) => {
  switch (action.type) {
    case types.ZOHO_GET_PLAN_SUCCESS:
      return action.plan
    case types.ZOHO_GET_PLAN_FAILURE:
      return null
    default:
      return state
  }
}

export const selectedTables = (state = [], action) => {
  switch (action.type) {
    case types.ZOHO_GET_SELECTED_TABLES_SUCCESS:
      return action.tables.map(table => get(table, 'queryTableName'))
    default:
      return state
  }
}

export default combineReducers({
  status,
  organisations,
  workspaces,
  organisationId,
  workspaceId,
  records,
  connecting,
  connectStep,
  changeRangeSelecting,
  reauthorising,
  authenticating,
  activating,
  deactivating,
  changingRange,
  gettingOrganisations,
  gettingWorkspaces,
  gettingRecords,
  authenticationError,
  activationError,
  changeRangeError,
  plan,
  selectedTables,
})
